/**
 * Assistance : les tickets qu'un cabinet ouvre, et que la plateforme traite.
 *
 * Ensembles fermés partagés entre la base (pgEnum), le serveur (zod) et le front (libellés i18n).
 * Règle : valeurs ASCII en snake_case, jamais de libellé humain ici. Ce fichier est réexporté par
 * `../enums.js`, qui reste le seul point d'entrée : personne n'importe un domaine directement.
 */

/**
 * État d'un ticket, et c'est **l'auteur du dernier message qui le pose**, jamais un geste séparé.
 * `open` : le cabinet attend une réponse. `answered` : la plateforme a répondu, la balle est chez
 * le cabinet. `closed` : l'affaire est réglée, par l'un ou par l'autre.
 *
 * Trois états et non cinq : la V1 n'avait aucun système de tickets, et un état qu'aucun écran ne
 * sait produire ni lire est exactement ce que l'audit a trouvé partout ailleurs.
 */
export const supportTicketStatuses = ['open', 'answered', 'closed'] as const;
export type SupportTicketStatus = (typeof supportTicketStatuses)[number];

/**
 * Catégorie déclarée par le cabinet à l'ouverture. Elle sert au tri de la file, pas au routage :
 * il n'y a pas d'équipes à qui router.
 */
export const supportTicketCategories = [
  'technique',
  'facturation',
  'compte',
  'donnees',
  'autre',
] as const;
export type SupportTicketCategory = (typeof supportTicketCategories)[number];

/**
 * Priorité **demandée** par le cabinet. C'est une indication, pas un engagement : rien dans le
 * produit ne promet un délai, et promettre ce qu'on ne tient pas coûte plus cher que de se taire.
 */
export const supportTicketPriorities = ['basse', 'normale', 'haute'] as const;
export type SupportTicketPriority = (typeof supportTicketPriorities)[number];

/**
 * De quel côté vient un message. Posé par le serveur d'après la route empruntée, jamais d'après le
 * corps de la requête : un cabinet ne doit pas pouvoir écrire un message qui a l'air de venir de
 * nous.
 */
export const supportMessageAuthorKinds = ['cabinet', 'platform'] as const;
export type SupportMessageAuthorKind = (typeof supportMessageAuthorKinds)[number];
